import * as actionTypes from 'constants/ActionTypes';

const gazetters = (state = {
    items: [], isLoaded: false, isError: false, error: {}, 
}, action) => {
    switch (action.type) {
    case actionTypes.REMOVE_ANNOTATIONS: {
        return {
            ...state,
            items: [],
            isLoaded: false,
        };
    }
    case actionTypes.REMOVE_GAZETTERS: {
        return {
            ...state,
            items: [],
        };
    }
    case actionTypes.POST_GAZETTERS.REQUEST:
        return {
            ...state,
            items: [],
        };
    case actionTypes.POST_GAZETTERS.SUCCESS:
        return {
            ...state,
            items: action.data.map((gazetter, key) => ({
                ...gazetter,
                id: key,
                state: '',
            })),
            isLoaded: true,
        };
    case actionTypes.POST_GAZETTERS.FAILURE:
        return {
            ...state,
            error: action.error,
            isLoaded: true,
        };
    case actionTypes.SAVE_GAZETTERS.REQUEST:
        return {
            ...state,
        };
    case actionTypes.SAVE_GAZETTERS.SUCCESS:
        return {
            ...state,
        };
    case actionTypes.SAVE_GAZETTERS.FAILURE:
        return {
            ...state,
            error: action.error,
        };

    default:
        return state;
    }
};

export default gazetters;



// WEBPACK FOOTER //
// ./app/reducers/gazetters.js